import axios from 'axios'

const axiosWrap = axios.create({
	// baseURL: 'https://s4.sheca.com/s4/471/', //测试环境
	baseURL: 'https://s1.sheca.com/s1/037/', //生产环境
	timeout: 1000 * 30,	//30秒
	headers: {},
})

/* 过滤请求 */
axiosWrap.interceptors.request.use((config) => {
	
	// const token = localStorage.getItem('ACCESS_TOKEN');
	// if (token) {
	// 	config.headers.Authorization = 'Bearer ' + token;
	// }

	return config
})

axiosWrap.interceptors.response.use(
	(result) => {
		if (result.status === 200) {
			if(result.data.code !== 0){
				return Promise.reject(new Error(result.data.msg))
			}else{
				return result.data		
			}
		} else {
			return Promise.reject(new Error('网络异常'))
		}
	},
	(err) => {
		console.log(err)
		return Promise.reject(err);

	}
)

export default axiosWrap


// WEBPACK FOOTER //
// ./src/api/request.js